export default "__VITE_ASSET__DVIBEWQw__"